<template>
    <TransitionEffect name="collapse">
        <div class="cookieBar">
            <div class="content">
                <div class="cookieDetails">
                    <Heading :h="3" size="s">
                        {{ siteContent.cookieBar.heading }}
                    </Heading>
                    <p class="p1">
                        {{ siteContent.cookieBar.p1 }}
                    </p>
                    <p class="p2">
                        {{ siteContent.cookieBar.p2 }}
                        <router-link to="/privacy">
                            {{ siteContent.privacy }}
                        </router-link>.
                    </p>
                </div>

                <div class="buttons">
                    <Button class="closeButton"
                        size="fullWidth"
                        appearance="secondary"
                        @click="updateCookiePreference('essential')">
                        {{ siteContent.cookieBar.allowEssential }}
                    </Button>
                    <Button class="closeButton"
                        size="fullWidth"
                        appearance="primary"
                        @click="updateCookiePreference('all')">
                        {{ siteContent.cookieBar.allowAll }}
                    </Button>
                </div>
            </div>
        </div>
    </TransitionEffect>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'CookieBar',
        methods: {
            ...mapActions('users',['acceptCookies']),

            updateCookiePreference(preference) {
                this.acceptCookies(preference)

                if(preference === 'all') {
                    this.$emit('setAnalyticsCookies')
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .cookieBar {
        position: fixed;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-self: center;
        width: 100%;
        max-width: 64rem;
        background: var(--color-grey-100);
        border-radius: 1rem;
        z-index: 11;
        margin-bottom: 1rem;
    }

    .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 2rem;
    }

    .cookieDetails {
        display: flex;
        flex-direction: column;
        margin-bottom: 2rem;
    }

    .buttons {
        display: flex;
    }

    .h3 {
        margin: 0 0 1.5rem 0;
    }

    .p1 {
        font-size: 1rem;
        margin: 0 0 1.5rem 0;
    }

    .p2 {
        font-size: 0.875rem;
        margin: 0;
    }

    .infoLink {
        color: var(--color-primary-500);
    }

    .closeButton {
        margin-right: 1rem;
    }

    @media all and (max-width: 1024px) {
        .cookieBar {
            width: 100%;
            max-width: 100%;
            margin-bottom: 0;
            border-radius: 1rem 1rem 0 0;
        }
    }

    @media all and (max-width: 560px) {
        .content {
            padding: 2rem 1.5rem;
            padding-bottom: calc(2rem + env(safe-area-inset-bottom));
        }

        .buttons {
            flex-direction: column;

            .closeButton {
                margin: 0 0 1rem 0;
            }
        }
    }
</style>